import React from 'react';
import { translate } from 'react-jhipster';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface POApprovalCardProps {
  count: number;
  onClick: () => void;
  onNavigate: (path: string) => void;
}

export const POApprovalCard = ({ count, onClick, onNavigate }: POApprovalCardProps) => {
  const safeCount = count > 0 ? count : 0;

  return (
    <Card className="action-paper" onClick={onClick}>
      <CardActionArea onClick={() => onNavigate('/home/#poTable')}>
        <CardContent sx={{ backgroundColor: '#EBF2F7' }}>
          <Grid container spacing={2}>
            <Grid item xs className="left-side-component-flex">
              <Typography variant="h6" sx={{ color: '#01579b' }}>
                <strong>{safeCount}</strong>
              </Typography>
            </Grid>
            <Grid item xs className="right-side-component-flex">
              <PendingActionsIcon className="icon-card" sx={{ color: '#01579b' }} />
            </Grid>
          </Grid>
          <Typography variant="body2" sx={{ color: '#01579b' }}>
            {translate('home.topInfo.poApproval.title')}&nbsp;
            <Tooltip title={`${translate('home.topInfo.poApproval.tooltip')}`}>
              <InfoOutlinedIcon sx={{ fontSize: 14, cursor: 'pointer' }} />
            </Tooltip>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default POApprovalCard;
